import {ErrorModel} from '../../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import {URL} from '../../root';
import {paymentTerms} from './defaultResponseModel/paymentTerms';
const FUNCTION_CODE = 'GET_ADMIN_DASHBOARD_PAYMENT_TERMS';

export async function getPaymentTerms(userToken: string, params: string) {
    try {
        const response = await axios.get(
            `${URL}/dashboards/partner/payment-terms/${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        return paymentTerms.from(response.data);
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
